import { createClient } from '@supabase/supabase-js';
import { SupabaseGameRepository } from './supabase/game-repository.js';
import { SupabaseUserRepository } from './supabase/user-repository.js';
export function createSupabaseClient(config) {
    if (!config.url || !config.publishableKey) {
        throw new Error('Supabase ist nicht konfiguriert. VITE_SUPABASE_URL und VITE_SUPABASE_PUBLISHABLE_KEY setzen (siehe .env.example).');
    }
    if (config.publishableKey.startsWith('sb_secret_')) {
        throw new Error('Es wurde ein Secret Key uebergeben. Der umgeht RLS und gehoert niemals in einen Client.');
    }
    return createClient(config.url, config.publishableKey, {
        auth: { persistSession: true, autoRefreshToken: true },
    });
}
/**
 * Serverseitiger Client mit Secret Key. Umgeht RLS – ausschliesslich fuer
 * Sync, Import und Admin-Jobs. Wird nie aus Client-Code aufgerufen.
 */
export function createSupabaseServiceClient(config) {
    if (!config.url || !config.secretKey) {
        throw new Error('SUPABASE_SECRET_KEY und Project URL werden benoetigt.');
    }
    return createClient(config.url, config.secretKey, {
        auth: { persistSession: false, autoRefreshToken: false },
    });
}
export class SupabaseRepositoryNotImplementedError extends Error {
    constructor(method) {
        super(`Supabase-Repository "${method}" kommt in Phase 2 (IGDB/PSN-Anbindung).`);
        this.name = 'SupabaseRepositoryNotImplementedError';
    }
}
function notImplemented(namespace) {
    return new Proxy({}, {
        get(_target, prop) {
            return () => Promise.reject(new SupabaseRepositoryNotImplementedError(`${namespace}.${String(prop)}`));
        },
    });
}
/**
 * Struktur steht, Implementierung folgt. Die App kann schon jetzt dagegen
 * gebaut werden, ohne dass sich spaeter eine Signatur aendert.
 */
export function createSupabaseApi(client) {
    return {
        // Erste echte Implementierung (Phase 2A). Die uebrigen folgen Screen fuer Screen.
        games: new SupabaseGameRepository(client),
        trophies: notImplemented('trophies'),
        roadmaps: notImplemented('roadmaps'),
        completion: notImplemented('completion'),
        // Nur die Lesepfade fuer die Account-UI; der Rest meldet sich weiterhin
        // als "noch nicht implementiert".
        users: new SupabaseUserRepository(client),
        vmaps: notImplemented('vmaps'),
    };
}
//# sourceMappingURL=supabase-api.js.map